/**
 * @module helper.array
 */
import { isArrayEmpty } from './isArrayEmpty';

/**
 * Remove specific index from source.
 */
export function removeIndex<T>(source: T[], index: number): T[] {
	if (!Array.isArray(source)) {
		throw new Error('source should be array.');
	} else if (isArrayEmpty(source)) {
		return source;
	}

	const resolvedIndex = index >= 0 ? index : source.length + index;

	if (resolvedIndex >= source.length) {
		return source;
	} else if (resolvedIndex === 0) {
		return source.slice(1, source.length);
	} else if (resolvedIndex === source.length - 1) {
		return source.slice(0, source.length - 1);
	}

	return [
		...source.slice(0, resolvedIndex),
		...source.slice(resolvedIndex + 1, source.length),
	];
}
